module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ml-3 overline"
  }, [_vm._v("\n    Delivery status\n  ")]), _vm._v(" "), _c('v-list', {
    staticClass: "mx-4",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.communications), function(comm) {
    return _c('v-list-tile', {
      key: comm.id
    }, [_c('v-list-tile-avatar', [(!_vm.isFailure(comm)) ? _c('v-icon', [_vm._v("check")]) : _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (comm) ? _c('v-list-tile-content', [(comm.preferred_transport === "email") ? _c('v-list-tile-title', _vm._l((comm.recipient_emails), function(email) {
      return _c('span', {
        key: email
      }, [_vm._v(_vm._s(email))])
    }), 0) : _vm._e(), _vm._v(" "), (comm.preferred_transport === "sms") ? _c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(comm.recipient_phone_number))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n        " + _vm._s(_vm.status(comm)) + "\n      ")])], 1)
  }), _vm._v(" "), (!_vm.communications || _vm.communications.length === 0) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "width": "2",
      "color": "amber"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          waiting for status updates\n        ")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_vm._v("Fetch from server")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-572c5338","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unibox/MessageDeliveryStatus.vue
// module id = 1430
// module chunks = 9